module.exports = __webpack_public_path__ + "img/dark-road-trees-thumb.b8bb2087.jpg";